import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer, Button, Highchartscomponent} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';
import Highcharts from 'highcharts';



Highcharts.setOptions({
colors: ['#660066', '#800080', '#be29ec', '#d896ff', '#efbbff',
    '#FDB9C8', '#DE6FA1', '#FB607F', '#DE3163', '#F81894']
});
const capital = {
  chart: {
        type: 'column'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Yes', 'No', 'Not sure']
    },
    yAxis: {
        min: 0,
        title: {
            text: ''
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'normal'
        }
    },
    series: [ {
        name: 'Monetary support received',
        data: [70, 28, 2]
    }]
}

const capital2 = {
  chart: {
        type: 'column'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Yes', 'No', 'Not sure']
    },
    yAxis: {
        min: 0,
        title: {
            text: ''
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'normal'
        }
    },
    series: [ {
        name: 'Participation in government supported programs',
        data: [65, 32, 2]
    }]
}



export class ChapterEightyOne extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {"" }
        </Subtopic>

        <TextHolder text="The survey findings show that 70 percent of respondents had not received grants or other monetary support from their governments. Neither have they participated in government programs aimed at supporting entrepreneurship. Given the wide availability of such grants and programs, this is a surprising response which merits deeper investigation in the next edition of this report. " />

        <TextHolder text="" />





          <Highchartscomponent   chartsText="Has your company received a grant or other monetary support from your national government, not including tax breaks?" options={capital} chartsBottomText="Additionally, most founders had not participated in government programs aimed at supporting entrepreneurship." source="Source: 2018 State of SE Asian Tech Survey" />

          <Highchartscomponent   chartsText="Have you or your company participated in any government programs aimed at supporting entrepreneurs?" options={capital2} source="Source: 2018 State of SE Asian Tech Survey"  />




          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/81.js